import { render, staticRenderFns } from "./BarChartLoading.vue?vue&type=template&id=05bd2cda"
import script from "./BarChartLoading.vue?vue&type=script&lang=js"
export * from "./BarChartLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports